export function canShowTooltip({ hasNotification, isMobile, allowMobile, hasChildren, hasPopover, hasTooltip }) {
    // if no children, nothing to show
    if (!hasChildren) {
        return false;
    }
    // if we have a notification, always show it
    if (hasNotification) {
        return true;
    }
    // mobile is explicitly opt-in
    // and we only care for the popover
    if (isMobile) {
        return allowMobile && hasPopover;
    }
    // need at least something to render
    return hasTooltip || hasPopover;
}

//# sourceMappingURL=helpers.js.map